import type { ProgramEventType } from 'models';
import { useTranslation } from 'react-i18next';

import { Col, Icon, Row, Space, Text } from 'ui';

import { Card } from './card';

type P = {
  description: string[];
  onChange: (eventType: ProgramEventType) => void;
  title: string;
  type: ProgramEventType;
};

const CardOption = ({ description, onChange, title, type }: P) => {
  const { t } = useTranslation();

  return (
    <Card
      content={
        <Row>
          {description.map((desc) => (
            <Col key={desc} span={24}>
              <Space>
                <Text>
                  <Icon icon="check-line" />
                </Text>
                <Text>{t(desc)}</Text>
              </Space>
            </Col>
          ))}
        </Row>
      }
      id={`event_card-${type}`}
      onClick={() => {
        onChange(type);
      }}
      title={t(title)}
      value={type}
    />
  );
};

export default CardOption;
